import PropTypes from 'prop-types';
import { a as dayjs } from './dateValidation-67caec66.js';
import 'react-dom';

class Logger {
  success(message) {
    console.log("%c".concat(message), 'color: green');
  }
  warning(message) {
    console.warn(message);
  }
  error(message) {
    console.error(message);
  }
  deprecate(message) {
    console.warn("DEPRECATION WARNING(gene-ui): ".concat(message));
  }
}
var Logger$1 = new Logger();

/*
 * Use this function for informing about
 * props that are in conflict with each other.
 */
const conflictPropsLog = function (componentName, props) {
  let isWarning = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const message = props.map(prop => "'".concat(prop, "'")).join(' and ');
  const logFunction = isWarning ? Logger$1.warning : Logger$1.error;
  logFunction("You can't specify ".concat(message, " props together for ").concat(componentName, " component."));
};

/*
 * Function will check does provided keyboard key codes
 * match with the one that bubbled event.
 */
const keyboardHandler = (e, keys) => keys.some(key => key === e.which || key === e.keycode);

/*
 * PropTypes.instanceOf works only for class components
 */
const childrenOf = types => {
  const type = PropTypes.shape({
    type: PropTypes.oneOf(types)
  });
  return PropTypes.oneOfType([type, PropTypes.arrayOf(type)]);
};

/*
 * One of specified props is required. Use for conditinal required props.
 */

const oneIsRequired = properties => {
  const keys = Object.keys(properties);
  return keys.reduce((acc, item) => {
    acc[item] = (props, propName, componentName) => {
      if (keys.every(key => !props.hasOwnProperty(key))) {
        return new Error("".concat(keys.join(' or '), " must be specified for ").concat(componentName));
      }
      PropTypes.checkPropTypes({
        [propName]: properties[propName]
      }, props, propName, componentName);
    };
    return acc;
  }, {});
};
const chunk = function (array) {
  let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const length = array && array.length;
  if (!array || !length) return [];
  if (size < 1) return array;
  let i = 0;
  let j = 0;
  const result = [];
  while (i < length) {
    result[j++] = array.slice(i, i += size);
  }
  return result;
};

/*
 * Display file size bytes
 */
const fileSizeDisplay = bytes => {
  if (!bytes || bytes < 1) return '0 Byte';
  const sizes = ['Byte', 'KB', 'MB', 'GB', 'TR'];
  const powerOfTwo = Math.floor(Math.log2(bytes) / 10);
  const i = powerOfTwo > 4 ? 4 : powerOfTwo;
  return "".concat(Math.floor(bytes / 2 ** (i * 10)), " ").concat(sizes[i]);
};
const getImageDimensions = image => new Promise((resolve, reject) => {
  if (window.Image && window.URL) {
    const img = new Image();
    img.src = window.URL.createObjectURL(image);
    img.onload = function () {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight
      });
      window.URL.revokeObjectURL(img.src);
    };
    img.onerror = error => {
      reject(error);
    };
  } else {
    reject();
  }
});
const interceptValue = (event, value) => ({
  ...event,
  target: {
    ...event.target,
    value
  }
});
const stopEvent = function (event) {
  let isPreventNeeded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  event.stopPropagation();
  isPreventNeeded && event.preventDefault();
};

/*
 *  This part for date filter organism,
 * functions are checking is your past date in right range or no.
 */

const getLMTD = (today, dayFromLastMonth) => {
  const dayOfMonth = today.date();
  const selectedDayOfMonth = dayFromLastMonth.startOf('month').date(dayOfMonth);
  return today.isSame(selectedDayOfMonth, 'month') ? dayFromLastMonth.endOf('month') : selectedDayOfMonth;
};
const isDateInRightRange = (rangeStart, rangeEnd, startDate, endDate) => rangeStart.isSame(startDate, 'day') && rangeEnd.isSame(endDate, 'day');
const isToday = (startDate, endDate) => {
  const today = dayjs();
  return isDateInRightRange(today, today, startDate, endDate);
};
const isYesterday = (startDate, endDate) => {
  const yesterday = dayjs().subtract(1, 'day');
  return isDateInRightRange(yesterday, yesterday, startDate, endDate);
};
const isThisWeek = (startDate, endDate) => {
  const startOfCurrentWeek = dayjs().startOf('week');
  const endOfCurrentWeek = dayjs().endOf('week');
  return isDateInRightRange(startOfCurrentWeek, endOfCurrentWeek, startDate, endDate);
};
const isLastWeek = (startDate, endDate) => {
  const startOfLastWeek = dayjs().subtract(7, 'day').startOf('week');
  const endOfLastWeek = dayjs().subtract(7, 'day').endOf('week');
  return isDateInRightRange(startOfLastWeek, endOfLastWeek, startDate, endDate);
};
const isThisMonth = (startDate, endDate) => {
  const startOfCurrentMonth = dayjs().startOf('month');
  const endOfCurrentMonth = dayjs().endOf('month');
  return isDateInRightRange(startOfCurrentMonth, endOfCurrentMonth, startDate, endDate);
};
const isLastMonth = (startDate, endDate) => {
  const startOfLastMonth = dayjs().subtract(1, 'month').startOf('month');
  const endOfLastMonth = dayjs().subtract(1, 'month').endOf('month');
  return isDateInRightRange(startOfLastMonth, endOfLastMonth, startDate, endDate);
};
const isLastMonthToDate = (startDate, endDate) => {
  const today = dayjs();
  const startOfLastMonth = today.subtract(1, 'month').startOf('month');
  const sameDayFromLastMonth = getLMTD(today, startOfLastMonth);
  return isDateInRightRange(startOfLastMonth, sameDayFromLastMonth, startDate, endDate);
};
const noop = () => {};
const getInitials = name => name.match(/\b(\w)/g).join('').substr(0, 2).toUpperCase();

export { Logger$1 as L, conflictPropsLog as a, isToday as b, childrenOf as c, isYesterday as d, isThisWeek as e, fileSizeDisplay as f, isLastWeek as g, isThisMonth as h, interceptValue as i, isLastMonth as j, keyboardHandler as k, isLastMonthToDate as l, getLMTD as m, noop as n, oneIsRequired as o, getImageDimensions as p, chunk as q, getInitials as r, stopEvent as s };
